import { render, staticRenderFns } from "./fl44-proposal-show.vue?vue&type=template&id=29575262&scoped=true&"
import script from "./fl44-proposal-show.vue?vue&type=script&lang=js&"
export * from "./fl44-proposal-show.vue?vue&type=script&lang=js&"
import style0 from "./fl44-proposal-show.vue?vue&type=style&index=0&id=29575262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29575262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29575262')) {
      api.createRecord('29575262', component.options)
    } else {
      api.reload('29575262', component.options)
    }
    module.hot.accept("./fl44-proposal-show.vue?vue&type=template&id=29575262&scoped=true&", function () {
      api.rerender('29575262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/proposals/fl44-proposal-show.vue"
export default component.exports